import React from "react";

import { graphql, useFragment } from "react-relay";

import { TodoEditTagsPopover_todo$key } from "./__generated__/TodoEditTagsPopover_todo.graphql";
import { useTodoEditSetTags } from "./useTodoEditSetTags";
import { TodoTagsDialog } from "../TodoDialogs/TodoTagsDialog";

export function TodoEditTagsPopover(props: {
  todo: TodoEditTagsPopover_todo$key;
  visible: boolean;
  onClose: () => void;
  currentEmployeeId: string | null;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditTagsPopover_todo on Todo {
        id
        tags {
          id
        }
        category {
          tags {
            id
            color
            title
          }
        }
      }
    `,
    props.todo
  );

  const [setTags] = useTodoEditSetTags(todo.id, props.currentEmployeeId);

  return (
    <TodoTagsDialog
      visible={props.visible}
      onClose={props.onClose}
      selectedTagIds={todo.tags.map((t) => t.id)}
      setSelectedTagIds={setTags}
      categoryTags={todo.category?.tags ?? []}
    />
  );
}
